import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ExpressedPreference from './expressed-preference-model'
import {
  CreateExpressedPreferenceAsync,
  DeleteExpressedPreferenceAsync,
  LoadExpressedPreferencesAsync,
} from './expressedPreference-thunk'
const initialState: expressedPreferenceSliceState = {
  expressedPreference: [],
  selected_expressedPreference: '',
  is_loading_expressedPreference: false,
  is_creating_expressedPreference: false,
  is_deleting_expressedPreference: false,
}
export interface expressedPreferenceSliceState {
  expressedPreference: ExpressedPreference[]
  selected_expressedPreference?: string
  is_loading_expressedPreference: boolean
  is_creating_expressedPreference: boolean
  is_deleting_expressedPreference: boolean
}
export const expressedPreferenceSlice = createSlice({
  name: 'expressedPreference',
  initialState,
  reducers: {
    setSelectedexpressedPreference: (state, action) => {
      state.selected_expressedPreference = action.payload
    },
    clearStateexpressedPreference: (state) => {
      state.expressedPreference = []
      state.is_loading_expressedPreference = false
      state.is_creating_expressedPreference = false
      state.is_deleting_expressedPreference = false
    },
    mergeexpressedPreference: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_expressedPreference = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.expressedPreference = merge(
            state.expressedPreference,
            payload,
          ) as any
        }
      }
    },

    add_expressedPreference: (state, action) => {
      if (action.payload) {
        state.expressedPreference = [
          ...state.expressedPreference,
          action.payload,
        ]
      }
    },
    set_expressedPreference: (state, action) => {
      let { key, value, id } = action.payload
      state.expressedPreference = state.expressedPreference.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadExpressedPreferencesAsync.pending, (state) => {
      state.is_loading_expressedPreference = true
    })
    builder.addCase(
      LoadExpressedPreferencesAsync.fulfilled,
      (state, action) => {
        state.is_loading_expressedPreference = false
        if (action.payload) {
          state.expressedPreference = action.payload
        }
      },
    )
    builder.addCase(LoadExpressedPreferencesAsync.rejected, (state) => {
      state.is_loading_expressedPreference = false
    })
    builder.addCase(CreateExpressedPreferenceAsync.pending, (state) => {
      state.is_creating_expressedPreference = true
    })
    builder.addCase(CreateExpressedPreferenceAsync.fulfilled, (state) => {
      state.is_creating_expressedPreference = false
    })
    builder.addCase(CreateExpressedPreferenceAsync.rejected, (state) => {
      state.is_creating_expressedPreference = false
    })
    builder.addCase(DeleteExpressedPreferenceAsync.pending, (state) => {
      state.is_deleting_expressedPreference = true
    })
    builder.addCase(
      DeleteExpressedPreferenceAsync.fulfilled,
      (state, action) => {
        state.is_deleting_expressedPreference = false
        if (state.expressedPreference) {
          state.expressedPreference = state.expressedPreference.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteExpressedPreferenceAsync.rejected, (state) => {
      state.is_deleting_expressedPreference = false
    })
  },
})

export const {
  clearStateexpressedPreference,
  setSelectedexpressedPreference,
  set_expressedPreference,
  mergeexpressedPreference,
  add_expressedPreference,
} = expressedPreferenceSlice.actions

export const get_expressedPreference =
  (id?: string) =>
  (state: {
    expressedPreference: {
      expressedPreference: ExpressedPreference[]
    }
  }): ExpressedPreference | null => {
    let temp = state?.expressedPreference?.expressedPreference?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.expressedPreference?.expressedPreference[0] || null
  }
export const get_selected_expressedPreference = (state: {
  expressedPreference: expressedPreferenceSliceState
}): ExpressedPreference | null => {
  let id = state?.expressedPreference?.selected_expressedPreference
  let temp = state?.expressedPreference?.expressedPreference?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_expressedPreference = (state: {
  expressedPreference: {
    expressedPreference: ExpressedPreference[]
  }
}): ExpressedPreference[] => {
  let temp = state?.expressedPreference?.expressedPreference
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_expressedPreference_busy = (state: {
  expressedPreference: expressedPreferenceSliceState
}) => {
  return (
    state?.expressedPreference.is_deleting_expressedPreference ||
    state?.expressedPreference.is_loading_expressedPreference ||
    state?.expressedPreference.is_creating_expressedPreference
  )
}
export const is_deleting_expressedPreference_busy = (state: {
  expressedPreference: expressedPreferenceSliceState
}) => {
  return state?.expressedPreference.is_deleting_expressedPreference
}
export const is_loading_expressedPreference_busy = (state: {
  expressedPreference: expressedPreferenceSliceState
}) => {
  return state?.expressedPreference.is_loading_expressedPreference
}
export const is_creating_expressedPreference_busy = (state: {
  expressedPreference: expressedPreferenceSliceState
}) => {
  return state?.expressedPreference.is_creating_expressedPreference
}

export default expressedPreferenceSlice.reducer
